import React from 'react';
import './BombGameResult.css';

const BombGameResult = ({ 
  isSuccess, 
  selectedCell,
  explanation,
  correctCells, 
  onPlayAgain,
  onBackToMenu,
  board // 追加：問題の盤面を受け取る
}) => {
  // ミニ数独盤面コンポーネント（ハイライト表示付き）
  const MiniSudokuBoard = ({ board, highlightCells }) => {
    return (
      <div className="mini-sudoku-board">
        {board.map((row, rowIndex) => (
          <div key={`row-${rowIndex}`} className="mini-board-row">
            {row.map((cell, colIndex) => {
              // ハイライト対象のセルか判定
              const isHighlighted = highlightCells.some(
                hCell => hCell.row === rowIndex && hCell.col === colIndex
              );
              
              // 選択したセルか判定
              const isSelected = selectedCell && 
                selectedCell.row === rowIndex && 
                selectedCell.col === colIndex;
              
              return (
                <div
                  key={`cell-${rowIndex}-${colIndex}`}
                  className={`
                    mini-board-cell
                    ${(rowIndex + 1) % 3 === 0 && rowIndex < 8 ? 'border-bottom' : ''}
                    ${(colIndex + 1) % 3 === 0 && colIndex < 8 ? 'border-right' : ''}
                    ${cell === 0 ? 'empty-cell' : 'filled-cell'}
                    ${isHighlighted ? 'correct-cell' : ''}
                    ${isSelected ? 'selected-cell' : ''}
                  `}
                >
                  {cell !== 0 ? cell : ''}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={`bomb-result ${isSuccess ? 'success' : 'failure'}`}>
      {isSuccess ? (
        <div className="success-result">
          <h2>おめでとう！正解です！ 🎉</h2>
          <p className="result-message">
            行{selectedCell.row + 1}、列{selectedCell.col + 1}のマスは安全に消せます。
            一意解が維持されます。
          </p>
          
          {/* 盤面表示（正解のマスをハイライト） */}
          <div className="board-visualization">
            <h3>盤面と正解マス:</h3>
            <MiniSudokuBoard 
              board={board} 
              highlightCells={correctCells} 
            />
            <p className="board-caption">
              緑色の数字が消しても一意解が保たれるマスです。
            </p>
          </div>
          
          {correctCells.length > 1 && (
            <div className="other-correct-answers">
              <h3>他の正解マス:</h3>
              <div className="correct-cells-list">
                {correctCells.filter(cell => 
                  !(cell.row === selectedCell.row && cell.col === selectedCell.col)
                ).map((cell, index) => (
                  <div key={index} className="correct-cell-item">
                    行{cell.row + 1}、列{cell.col + 1}の「{cell.value}」
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="failure-result">
          <h2>残念！不正解です 💥</h2>
          <p className="result-message">
            行{selectedCell.row + 1}、列{selectedCell.col + 1}の「{selectedCell.value}」
            を消すと、一意解が維持できなくなります。
          </p>
          
          {/* 盤面表示（正解のマスと選択したマスをハイライト） */}
          <div className="board-visualization">
            <h3>盤面と正解マス:</h3>
            <MiniSudokuBoard 
              board={board} 
              highlightCells={correctCells} 
            />
            <p className="board-caption">
              緑色の数字が安全に消せるマス、赤色の数字があなたが選んだマスです。
            </p>
          </div>
          
          <div className="explanation-section">
            <h3>解説:</h3>
            <p className="explanation-text">{explanation}</p>
            
            <div className="hint-section">
              <h3>ヒント:</h3>
              <p>安全に消せるマスは以下の条件を満たします:</p>
              <ul className="hint-list">
                <li>そのマスを消しても、数独の解が一意（1つだけ）に決まる</li>
                <li>行、列、3x3ブロック内の他の数字から十分な制約がある</li>
                <li>複数の可能性がある数字が入るマスができない</li>
              </ul>
              
              <div className="correct-answers">
                <h4>正解のマス:</h4>
                <div className="correct-cells-list highlight">
                  {correctCells.map((cell, index) => (
                    <div key={index} className="correct-cell-item">
                      行{cell.row + 1}、列{cell.col + 1}の「{cell.value}」
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      
      <div className="bomb-result-actions">
        <button className="action-button play-again" onClick={onPlayAgain}>
          もう一度プレイ
        </button>
        <button className="action-button back-to-menu" onClick={onBackToMenu}>
          メニューに戻る
        </button>
      </div>
    </div>
  );
};

export default BombGameResult;